import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, map, take } from 'rxjs/operators';

import { User } from 'app/auth/models';
import { TokenOAuth } from '../models/token-oauth';
import { UserOAuth } from '../models/user-oauth';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {

  public userOAuth: Observable<UserOAuth>;
  private userOAuthSubject: BehaviorSubject<UserOAuth>;

  public tokenOAuth: Observable<TokenOAuth>;
  private tokenOAuthSubject: BehaviorSubject<TokenOAuth>;

  public currentUser: Observable<User>;
  public currentUserSubject: BehaviorSubject<User>;

  /**
   *
   * @param {HttpClient} _http
   * @param {ToastrService} _toastrService
   */
  constructor(private _http: HttpClient) {
    this.userOAuthSubject = new BehaviorSubject<UserOAuth>(null);
    this.userOAuth = this.userOAuthSubject.asObservable();

    this.tokenOAuthSubject = new BehaviorSubject<TokenOAuth>(null);
    this.tokenOAuth = this.tokenOAuthSubject.asObservable();

    this.currentUserSubject = new BehaviorSubject<User>(null);
    this.currentUser = this.currentUserSubject.asObservable();
  }

  public get userOAuthValue(): UserOAuth {
    return this.userOAuthSubject.value;
  }

  public get tokenOAuthValue(): TokenOAuth {
    return this.tokenOAuthSubject.value;
  }

  public get currentUserValue(): User {
    return this.currentUserSubject.value;
  }

  public setCompany(empresaId: number, empresaNome: string, empresaMidiaCaminho: string, idInstanciaAV: string, idIntegracaoAV: string)  {
    let user = this.currentUserValue;
    user.empresaId = empresaId;
    user.empresaNome = empresaNome;
    user.empresaMidiaCaminho = empresaMidiaCaminho;
    user.empresaIdInstanciaAV = idInstanciaAV;
    user.empresaIdIntegracaoAV = idIntegracaoAV;
    this.currentUserSubject.next(user);
  }

  /**
   *  Confirms if user is admin
   */
  get isAdmin() {
    return this.currentUser && this.currentUserSubject.value.admin === true;
  }

  /**
   *  Confirms if user is client
   */
  get isClient() {
    return this.currentUser && this.currentUserSubject.value.admin === false;
  }

  authenticate(code: string, refreshToken: boolean = false) {
    return this._http
      .post<any>(process.env.APIURL + "api/oauth/authenticate", { codigoAutorizacao: code, ambiente: process.env.REDIRECTURI, refreshToken: refreshToken })
      .pipe(
        catchError(err => {
          if (err) {
            return throwError(err);
          }
        }),
        take(1)
      )
      .pipe(map((res: any) => res.data));
  }

  getProfile() {
    return this._http
      .get<any>(process.env.APIURL + "api/perfil")
      .pipe(
        catchError(err => {
          if (err) {
            return throwError(err);
          }
        }),
        take(1)
      )
      .pipe(map((res: any) => res.data));
  }

  setUserOAuth(userOAuth: UserOAuth) {
    this.userOAuthSubject.next(userOAuth);
  }

  setTokenOAuth(tokenOAuth: TokenOAuth) {
    this.tokenOAuthSubject.next(tokenOAuth);
    
  }

  registerUser(user: User) {
    this.currentUserSubject.next(user);
  }

  /**
   * User logout
   *
   */
  logout() {
    this.currentUserSubject.next(null);
  }

}
